import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  flex-grow: 1;\n  /* &:hover {\n    color: #000;\n  } */\n  height: ",
        "px;\n  line-height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n  justify-content: inherit;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import { useTranslation } from "@noahswap/localization";
import * as IconModule from "../icons";
import Accordion from "./Accordion";
import { MenuEntry } from "./MenuEntry";
import MenuLink from "./MenuLink";
import { MENU_ENTRY_HEIGHT } from "../config";
import PanelFooter from "./PanelFooter";
var Icons = IconModule;
var LinkLabel = styled.div.withConfig({
    componentId: "sc-bfdc7bc0-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#000" : "#fff";
}, MENU_ENTRY_HEIGHT, MENU_ENTRY_HEIGHT);
var Container = styled.div.withConfig({
    componentId: "sc-bfdc7bc0-1"
})(_templateObject1());
var PanelBody = function(param) {
    var isPushed = param.isPushed, pushNav = param.pushNav, isMobile = param.isMobile, links = param.links;
    var location = useRouter();
    var t = useTranslation().t;
    // Close the menu when a user clicks a link on mobile
    var handleClick = isMobile ? function() {
        return pushNav(false);
    } : undefined;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: links.map(function(entry) {
                    var Icon = entry.icon;
                    // const iconElement = <Icon width="24px" mr="8px" />;
                    var iconElement = entry.href === location.pathname ? /*#__PURE__*/ _jsx("img", {
                        src: "/images/small-img/".concat(Icon, "-active.png"),
                        width: 24,
                        alt: "logo",
                        style: {
                            marginRight: "6px"
                        }
                    }) : /*#__PURE__*/ _jsx("img", {
                        src: "/images/small-img/".concat(Icon, ".png"),
                        width: 24,
                        alt: "logo",
                        style: {
                            marginRight: "6px"
                        }
                    });
                    var calloutClass = entry.calloutClass ? entry.calloutClass : undefined;
                    if (entry.items) {
                        var itemsMatchIndex = entry.items.findIndex(function(item) {
                            return item.href === location.pathname;
                        });
                        var initialOpenState = entry.initialOpenState === true ? entry.initialOpenState : itemsMatchIndex >= 0;
                        // console.log(initialOpenState, 'initialOpenStateinitialOpenState')
                        // console.log(itemsMatchIndex, 'itemsMatchIndexitemsMatchIndex')
                        return /*#__PURE__*/ _jsx(Accordion, {
                            isPushed: isPushed,
                            pushNav: pushNav,
                            icon: iconElement,
                            label: entry.label,
                            initialOpenState: initialOpenState,
                            className: calloutClass,
                            children: isPushed && entry.items.map(function(item) {
                                return /*#__PURE__*/ _jsx(MenuEntry, {
                                    secondary: true,
                                    isActive: item.href === location.pathname,
                                    onClick: handleClick,
                                    children: /*#__PURE__*/ _jsx(MenuLink, _object_spread_props(_object_spread({
                                        to: item.href
                                    }, item), {
                                        prefetch: false,
                                        children: /*#__PURE__*/ _jsxs(LinkLabel, {
                                            isActive: item.href === location.pathname,
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    style: {
                                                        fontSize: "24px",
                                                        marginRight: "5px"
                                                    },
                                                    children: "\xb7"
                                                }),
                                                t("".concat(item.label))
                                            ]
                                        })
                                    }))
                                }, item.href);
                            })
                        }, entry.label);
                    }
                    return /*#__PURE__*/ _jsx(MenuEntry, {
                        isActive: entry.href === location.pathname,
                        className: calloutClass,
                        onClick: handleClick,
                        children: /*#__PURE__*/ _jsxs(MenuLink, _object_spread_props(_object_spread({
                            to: entry.href
                        }, entry), {
                            prefetch: false,
                            children: [
                                iconElement,
                                /*#__PURE__*/ _jsx(LinkLabel, {
                                    isActive: entry.href === location.pathname,
                                    children: t("".concat(entry.label))
                                })
                            ]
                        }))
                    }, entry.label);
                })
            }),
            /*#__PURE__*/ _jsx(PanelFooter, {
                isDark: false,
                links: links,
                isPushed: isPushed,
                pushNav: pushNav
            })
        ]
    });
};
export default PanelBody;
